import { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Home from "./pages/Home";
import PaymentForm from "./pages/Forms/PaymentForm";
import Header from "./Components/Header";
import PrivacyPolicy from "./pages//Privacy/PrivacyPolicy";
import Footer from "./Components/Footer";
import SuccessScreen from "./pages/Success";
import Contact from "./pages/Contact";
import { ToastContainer } from "react-toastify";
import TermsAndConditions from "./pages/TermsAndConditions/TermsAndCondition";
import ChildSafety from "./pages/ChildSafety/ChildSafety";
import { trackVisit } from "./utils/visitorTracking";

function App() {
  useEffect(() => {
    trackVisit();
  }, []);

  return (
    <div className="App">
      <FontAwesomeIcon icon={["fab", "apple"]} />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable={false}
        theme="dark"
        toastClassName="lh-toast"
        progressClassName="lh-toast-progress"
      />
      {/* <Header /> */}
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/*" element={<h1>404 Page Not Found</h1>} />
        <Route path="/payment/:token" element={<PaymentForm />} />
        <Route path="/payment-success" element={<SuccessScreen />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/child_safety" element={<ChildSafety />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
